import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';

import classes from '../../../App.module.css';
import { POTENTIAL_PAYOUT_ROUTE } from '../constants/PotentialPayoutConstants';
import Description from '../components/OriginalPotentialPayoutDescription';
import CodeBlock from 'components/layout/code-block/CodeBlock';
import TestBlock from 'components/layout/test-block/TestBlock';
import { UtilsTypes } from 'constants/utilsTypes';
import { OriginalPotentialPayoutParamsTypeSchema } from '@kambi/betting-client-helpers';

const GetOriginalPotentialPayout = () => {
    const navigate = useNavigate();

    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate(`/${POTENTIAL_PAYOUT_ROUTE}`)}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
            </div>
            <div className={classes.Content}>
                <div className={classes.Title}>Original Potential Payout</div>
                <div className={classes.Main}>
                    <Description />
                    <Divider />
                    <CodeBlock
                        title="General input for the getOriginalPotentialPayout method"
                        initialDisplayedCode={`{
	"betBuilders": [{
		"selectedOdds": {
			"decimal": 1100,
			"american": "-1000",
			"fractional": "1/10"
		},
		"selectedOutcomeIds": [100]
	}],
	"betOffers": [{
		"id": 300,
		"eachWay": {
			"fractionMilli": 1200
		}
	}],
	`}
                        moreCode={`"hasSelectedTeaser": true,
	"selectedOutcomes": [{
		"id": 100,
		"odds": 1100,
		"nrOfPermutations": 2,
		"betOfferId": 300
	}],
	"selectedReward": {
		"isProfitBoost": true,
		"boostPercentage": 10
	},
	"selectedTab": "single",
	"stakes": [{
		"stake": 1,
		"outcomeId": 100,
		"toWinInput": 100,
		"eachWaySelected": false,
		"type": "teaser"
	}]
}`}
                    />
                    <TestBlock
                        validationSchema={
                            OriginalPotentialPayoutParamsTypeSchema
                        }
                        title="You can test the getOriginalPotentialPayout() method by adding the input parameters as
                a JSON object in the below textarea, click Run and check the
                Output in the right"
                        type={UtilsTypes.ORIGINAL_POTENTIAL_PAYOUT}
                    />
                </div>
            </div>
        </div>
    );
};

export default GetOriginalPotentialPayout;
